module.exports = __webpack_public_path__ + "static/media/wheelchair.cd5b5d66.svg";